import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { IProps, IState } from './types';
import * as S from './styles';
import { default as C } from '@assets/themes/colors';
import { default as D } from '@assets/themes/dimensions';
import { setParams, getParams } from '@utils/userUtils';

const Menu:React.FC<IProps> = (props) => {

  const history: any = useHistory()

  const [menuOptions, setMenuOptions] = useState(props.initialMenuOptions);
  const [selected, setSelected] = useState(1);

  useEffect(() => {
    var optionIndex = menuOptions.findIndex((option:any) => option.id === props.pageIndex);
    if (optionIndex > -1)
      setSelected(menuOptions[optionIndex].id);
  }, [])

  const selectOption = (index:number) => {
    const params = getParams(history.location);
    var url = "";
    if (params.page) {
      if (params.page === "new-template") {
        url = setParams({ page: "new-template" });
        url =`?${url}`;     
      }
    }
    history.push({pathname: `/${menuOptions[index].url}`, search: url});
    setSelected(menuOptions[index].id)
  }

  const menuOption = (option:any, index:number) => {
    return (
      <S.OptionsContainer key={index} >
        <S.Option 
          onClick={() => selectOption(index)} 
          style={{ 
            color: selected === option.id ? C.DARK_ORANGE : C.WHITE
          }}
        >
          {option.title}
        </S.Option>
      </S.OptionsContainer>
    )
  }

  const containerOption = () => {
    return (
      <>
        <S.MenuTitle>
          DESIGN STUDIO
        </S.MenuTitle>
        {
          menuOptions.map((option:any, index:number) => {
            return menuOption(option, index);
          })
        }
      </>
    )
  }

  return (
    <S.Root>
      <S.MenuContainerInit style={{
        width: !props.openMenu ? `${D.VERTICAL_MENU_WIDTH}px` : '0px',
        opacity: !props.openMenu ? 1 : 0,
      }} >
        {containerOption()}
      </S.MenuContainerInit>
    </S.Root>
  );
}

export default Menu;